import { post } from './requests';

export const contactUs = (params) =>
    post('/contact-us', params, {
        message: 'Failed to submit form',
    });
